import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'achoo-dropzone',
  templateUrl: './achoo-dropzone.component.html',
  styleUrls: ['./achoo-dropzone.component.scss']
})
export class AchooDropzoneComponent implements OnInit {

  @Output() uploadErrorEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() uploadSuccessEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() message: string;
  @Input() config: any;
  @Input() disabled = false;

  constructor() { }

  ngOnInit() {
  }

  onUploadError(evt) {
    this.uploadErrorEvent.emit(evt);
  }

  onUploadSuccess(evt) {
    this.uploadSuccessEvent.emit(evt);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-dropzone/achoo-dropzone.component.ts